import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BotIcon, BookOpenIcon, MessageCircleIcon, ClipboardListIcon, SparklesIcon, CalendarIcon, BarChart3Icon, LayoutGridIcon } from 'lucide-react';
const items = [{
  label: 'AI选校匹配',
  icon: BotIcon,
  bg: '#8B5CF6',
  to: '/ai-match'
}, {
  label: '院校库',
  icon: BookOpenIcon,
  bg: '#2b6ef5',
  to: '/schools'
}, {
  label: '机构咨询',
  icon: MessageCircleIcon,
  bg: '#10B981',
  to: '/community'
}, {
  label: '申请规划',
  icon: ClipboardListIcon,
  bg: '#F59E0B',
  to: '/planner'
}, {
  label: 'AI择校',
  icon: SparklesIcon,
  bg: '#EC4899',
  to: '/ai-match'
}, {
  label: '规划助手',
  icon: CalendarIcon,
  bg: '#06B6D4',
  to: '/planner'
}, {
  label: '机构分析',
  icon: BarChart3Icon,
  bg: '#F97316',
  to: '/agency-analysis'
}, {
  label: '更多',
  icon: LayoutGridIcon,
  bg: '#94A3B8',
  to: '/more'
}];
export function QuickEntries() {
  const nav = useNavigate();
  return <div className="mx-3 mt-3 bg-white rounded-2xl p-4 shadow-sm" data-id="element-101">
      <div className="grid grid-cols-4 gap-y-5 gap-x-2" data-id="element-102">
        {items.map(it => {
        const Icon = it.icon;
        return <button key={it.label} onClick={() => nav(it.to)} className="flex flex-col items-center gap-2 active:scale-95 transition" data-id="element-103">
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-white" style={{
            background: `linear-gradient(135deg, ${it.bg}, ${it.bg}cc)`,
            boxShadow: `0 4px 10px ${it.bg}55`
          }} data-id="element-104">
                <Icon size={22} strokeWidth={2.2} data-id="element-105" />
              </div>
              <span className="text-[12px] text-slate-700" data-id="element-106">{it.label}</span>
            </button>;
      })}
      </div>
    </div>;
}